// Hierarchical Level (HL) code lists for the 856 — BSN05 (Hierarchical
// Structure Code), HL03 (Hierarchical Level Code) and HL04 (Hierarchical
// Child Code). These drive the Shipment/Order/Pack/Tare/Item tree the
// parser builds from each HL segment's HL01/HL02/HL03.

import type {CodeListEntry} from './types';

export const HIERARCHICAL_STRUCTURE_CODES: CodeListEntry[] = [
  {code: '0001', label: 'Shipment, Order, Packaging, Item'},
  {code: '0002', label: 'Shipment, Order, Item, Packaging'},
  {code: '0004', label: 'Shipment, Order, Item'},
];

export const HIERARCHICAL_LEVEL_CODES: CodeListEntry[] = [
  {code: 'S', label: 'Shipment'},
  {code: 'O', label: 'Order'},
  {code: 'T', label: 'Shipping Tare'},
  {code: 'P', label: 'Pack'},
  {code: 'I', label: 'Item'},
];

export const HIERARCHICAL_CHILD_CODES: CodeListEntry[] = [
  {
    code: '1',
    label:
      'Additional Subordinate HL Data Segment in This Hierarchical Structure',
  },
  {
    code: '0',
    label: 'No Subordinate HL Segment in This Hierarchical Structure',
  },
];
